module.exports = __webpack_public_path__ + "static/img/24.1ab2afc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scene/24.jpg
// module id = 3dxb
// module chunks = 0